import countries from '@/data/countries'

import { find } from 'lodash'

export function mapCountry(code) {
  const country = find(countries, { code })

  return country ? country.name : code
}
